(ns practitest.frontend.dashboard-item-settings.main
  (:require [practitest.frontend.dashboard-item-settings.views :as views]
            [practitest.frontend.dashboard-item-settings.events :as events]
            [re-frame.core :as re-frame]))

(defn new-page []
  [views/page {:edit? false}])

(defn edit-page []
  [views/page {:edit? true}])

(defn form-controller []
  {:start (fn [_] (re-frame/dispatch [::events/init]))
   :stop  (fn [_] (re-frame/dispatch [::events/cleanup]))})
